import { store } from "../store/store";

export default (to, from, next) => {
  const user = store.getters.user;
  if (to.matched.some((m) => m.meta.loginRequired)) {
    // impide que un usuario acceda a una ruta a la cual no tiene permiso
    if (to.path !== "/503" && user.scope && !user.scope.includes(to.name)) {
      console.log("user dont have the required scope");
      next("/503");
    } else {
      next();
    }
  } else {
    next();
  }
};
